module.exports = __webpack_public_path__ + "img/art-tiao-icon2.f06e282b.png";